import { jsx as _jsx } from "react/jsx-runtime";
var REACT_ELEMENT_TYPE;

function _jsx2(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { StyleSheet } from 'react-native';
import hoistNonReactStatics from 'hoist-non-react-statics';
import GestureHandlerRootView from './GestureHandlerRootView';
export default function gestureHandlerRootHOC(Component, containerStyles = undefined) {
  function Wrapper(props) {
    return /*#__PURE__*/_jsx2(GestureHandlerRootView, {
      style: [styles.container, containerStyles]
    }, void 0, /*#__PURE__*/_jsx(Component, { ...props
    }));
  }

  Wrapper.displayName = "gestureHandlerRootHOC(".concat(Component.displayName || Component.name, ")");
  hoistNonReactStatics(Wrapper, Component);
  return Wrapper;
}
const styles = StyleSheet.create({
  container: {
    flex: 1
  }
});